import React from 'react';
import PropType from 'prop-types';
import { useNavigate } from 'react-router-dom';

import './ClaimDetails.css';

class ClaimDetailsClass extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ClaimId: this.props.ClaimId,
      CustAppId: this.props.CustAppId,
      ClaimType: this.props.ClaimType,
      GlassPosition: this.props.GlassPosition,
      CauseOfLoss: this.props.CauseOfLoss,
      Excess: this.props.Excess,
      PaymentStatus: this.props.PaymentStatus,
      currentStatus: this.props.currentStatus,
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState({
      ClaimId: newProps.ClaimId,
      CustAppId: newProps.CustAppId,
      ClaimType: newProps.ClaimType,
      GlassPosition: newProps.GlassPosition,
      CauseOfLoss: newProps.CauseOfLoss,
      Excess: newProps.Excess,
      PaymentStatus: newProps.PaymentStatus,
      currentStatus: newProps.currentStatus,
    });
  }

  render() {
    const styleExcess = {
      color: this.state.PaymentStatus || this.state.Excess === '0.00' || this.state.currentStatus < 2 ? 'green' : 'red',
    };

    const tmpExcess = this.state.currentStatus < 2 ? 'Awaiting confirmation' : (
      <span style={styleExcess}>
        R
        {this.state.Excess}
        {' '}
        {this.state.PaymentStatus && this.state.Excess !== '0.00' ? '(PAID)' : ''}
      </span>
    );

    return (
      <div className="col-xs-12" id="claim-details">
        <h4 className="text-left">
          Claim Details: ID
          {this.state.ClaimId}
        </h4>
        <h5 className="hidden">
          Reference ID:
          {' '}
          {this.state.CustAppId}
        </h5>
        <div className="row">
          <div className="col-xs-5 small text-left">
            <b>Claim Type:</b>
          </div>
          <div className="col-xs-7 small text-left">
            {this.state.ClaimType}
          </div>
          <div className="col-xs-5 small text-left">
            <b>Glass Position:</b>
          </div>
          <div className="col-xs-7 small text-left">
            {this.state.GlassPosition}
            {' '}
            <br />
          </div>
          <div className="col-xs-5 small text-left">
            <b>Cause Of Loss:</b>
          </div>
          <div className="col-xs-7 small text-left">
            {this.state.CauseOfLoss}
            {' '}
            <br />
          </div>
          <div className="col-xs-5 small text-left">
            <b>Excess:</b>
          </div>
          <div className="col-xs-7 small text-left">
            {tmpExcess}
          </div>
        </div>
      </div>
    );
  }
}

ClaimDetailsClass.propTypes = {
  ClaimId: PropType.number,
  CustAppId: PropType.string,
  ClaimType: PropType.string,
  GlassPosition: PropType.string,
  CauseOfLoss: PropType.string,
  Excess: PropType.string,
  PaymentStatus: PropType.bool,
  currentStatus: PropType.number,
};

ClaimDetailsClass.defaultProps = {
  ClaimId: 0,
  CustAppId: '',
  ClaimType: '',
  GlassPosition: '',
  CauseOfLoss: '',
  Excess: '0.00',
  PaymentStatus: false,
  currentStatus: 0,
};

function ClaimDetails(props) {
  const navigate = useNavigate();
  return <ClaimDetailsClass {...props} navigate={navigate} />;
}

export default ClaimDetails;
